SWR.Social.prototype._getFacebookParams = function _getFacebookParams() {
  var self = this;
  var data = {};

  //Facebook:
  if (/^https?:\/\/www\.facebook\.com.*\/(video(s)?|watch|story)(\.php?|\/).+$/gim.test(self.url)) {
    // Facebook Video
    console.log("VIDEO", self.url);
    data.endpoint = 'https://graph.facebook.com/v13.0/oembed_video';
    data.params = {
      'access_token': self.fbAppId + '|' + self.fbAccessToken,
      'omitscript': false
    };
    data.dataType = 'jsonp';
  } /*else if (/(?:http:\/\/)?(?:www\.)?facebook\.com\/(?:(?:\w)*#!\/)?(?:pages\/)?(?:[\w\-]*\/)*([\w\-]*)/gim.test(self.url)){
    // Facebook Site
    console.log("PAGE", self.url);
    data.endpoint = 'https://graph.facebook.com/v13.0/oembed_page';
    data.params = {
      'access_token': self.fbAppId + '|' + self.fbAccessToken,
      'omitscript': false
    };
    data.dataType = 'json';
  }*/
  else if (/^(http(s?):)?\/\/((www\.)?)facebook\.com\/?/gmi.test(self.url)) {
    // Facebook Post
    console.log("POST", self.url);
    data.endpoint = 'https://graph.facebook.com/v13.0/oembed_post';
    data.params = {
      'access_token': self.fbAppId + '|' + self.fbAccessToken,
      'omitscript': false
    };
    data.dataType = 'json';
  }

  /* else if ('facebook-site' === self.config.embedType) {
    // Facebook Site
    loadFacebookSDK();

    self.$preview.hide();
    self.$content.show();
    self.$footer.show();
    self.$element.attr({
      'aria-busy': 'false'
    });
    self.$element.removeClass('embed-loading').addClass('embed-loaded');
    self._processing = false;
    self._processed = true;

    return;
  }*/

  return data;
};

SWR.Social.prototype._loadFacebookSDK = function _loadFacebookSDK(options, callback) {
  if ('undefined' !== typeof window.FB) {
    try {
      window.FB.init({
        status: false,
        cookie: false,
        xfbml: true,
        version: 'v14.0'
      })
    } catch (e) {
      (console.error || console.log).call(console, e.stack || e)
    }
  } else {
    // Load the SDK Asynchronously
    SWR.Util.loadScript('facebook-jssdk', '//connect.facebook.net/de_DE/sdk.js#xfbml=1&version=v14.0')
  }
};
